// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1B25D","actionsCol":"EnrolledClinics_actionsCol__3qorw"};